<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import { computed } from 'vue';
import { getUnitAmenities } from 'dashboard/helper/lais/imovelPresenter';

const props = defineProps({
  imovel: { type: Object, default: () => ({}) },
  items: { type: Array, default: () => [] },
});

const amenities = computed(() =>
  props.items.length ? props.items : getUnitAmenities(props.imovel)
);
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <section class="grid gap-3">
    <h3 class="text-[16px] font-semibold text-lais-text">
      Características da unidade
    </h3>
    <ul class="grid grid-cols-2 gap-2">
      <li
        v-for="item in amenities"
        :key="item.type"
        class="flex min-h-[72px] items-start gap-3 rounded-lais-sm border px-3 py-3 text-[13px]"
        :class="
          item.disabled
            ? 'border-lais-border-soft bg-lais-bg-soft text-lais-text-muted'
            : 'border-lais-border bg-white text-lais-text'
        "
      >
        <span
          :class="item.icon"
          class="mt-0.5 size-5 shrink-0"
          aria-hidden="true"
        />
        <span class="min-w-0">
          <span class="block font-semibold leading-tight">
            {{ item.title }}
          </span>
          <span
            v-if="item.description"
            class="mt-1 block text-[12px] leading-tight text-lais-text-helper"
          >
            {{ item.description }}
          </span>
        </span>
      </li>
    </ul>
  </section>
</template>
